import DefaultLayout from "layouts/Default";
import Wrapper from "components/blocks/Wrapper";
import Container from "components/blocks/Container";
import {useRouter} from "next/router";
import SignupForm from "components/forms/SignupForm";
import {wrapper} from "lib/store";
import {serverSideTranslations} from "next-i18next/serverSideTranslations";
import {useTranslation} from "next-i18next";
import {useState} from "react";

export const getServerSideProps = wrapper.getServerSideProps(store => async (context) => {
  const {
    locale
  } = context

  return {
    props: {
      ...(await serverSideTranslations(locale, ['home', 'common']))
    }
  }
})

export default function SignUp() {
  const router = useRouter()

  const handleSignUpSuccess = () => {
  }
  const { t, i18n } = useTranslation()



  return (
      <Wrapper className={'py-36'}>
        <Container className={'max-w-sm m-auto'}>
          <h2 className={'text-3xl font-bold text-center mb-8'}>
            {t('home:signUp')}
          </h2>
          <SignupForm onSuccess={handleSignUpSuccess} t={t}/>
        </Container>
      </Wrapper>
  )
}

SignUp.getLayout = function getLayout(page) {
  return (
      <DefaultLayout>
        {page}
      </DefaultLayout>
  )
}
